import { useState } from "react"
import { Colors } from "../../../../../colors"
import { EdiTextVariant } from "../../../../../components/base/edit-text/constants"
import EditText from "../../../../../components/base/edit-text/edit-text"
import i18n from "../../../../../translations/strings"
import { SearchTabReservationStyled } from "./search-tab-reservation.styled"
import SearchIcon from '@mui/icons-material/Search';

export interface SearchTabReservationProps {
    onSearchClick: (id: string) => void
}


const SearchTabReservation = (props: SearchTabReservationProps) => {

    const [searchIdReservation, setSearchIdReservation] = useState('')

    return (
        <SearchTabReservationStyled.ContainerSearch>
            <SearchTabReservationStyled.ContainerEditSearch>
            <EditText
                variant={EdiTextVariant.Standard}
                placeholder={i18n.t('handleReservation.placeholderSearchReservation')}
                onChange={(event: any) => setSearchIdReservation(event.target.value)}
                label={i18n.t('handleReservation.labelSearchReservation')}
            />
            </SearchTabReservationStyled.ContainerEditSearch>
            <SearchTabReservationStyled.ContainerIconSearch  onClick={() => searchIdReservation && props.onSearchClick(searchIdReservation)}>
                <SearchIcon sx={ { color: Colors.DarkGrey }} />
            </SearchTabReservationStyled.ContainerIconSearch>
        </SearchTabReservationStyled.ContainerSearch>
    )
}

export default SearchTabReservation;